// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".goods-list-box[data-v-28640ac3] {\n  background-color: #e9e7e6;\n  min-height: calc(var(--vh) * 100 - 1.33333rem);\n}\n.goods-list-box .list-box[data-v-28640ac3] {\n  min-height: calc(var(--vh) * 100 - 4rem);\n}\n", ""]);
// Exports
module.exports = exports;
